<template>
  <div id="publish" class="columns is-variable is-6">
    <div class="column is-4">
      <loader :loading="loading" :fixed="false"></loader>
      <span>{{ $resx("Publish.Publications") }}</span>
      <div class="lasttwo">
        <span>{{ $resx("Publish.LastTwo") }}</span>
        <ul>
          <li class="placeholder" v-if="lastTwo.length === 0">
            <span>{{ $resx("Publish.NoLast") }}</span>
          </li>
          <li v-for="(publish, idx) in lastTwo" :key="idx">
            <img
              :src="
                'https://cdn.' +
                $store.state.base +
                '/users/' +
                publish.CreatedBy +
                '/avatar/circle.png'
              "
            />
            <span>{{ formatDate(publish.PublishMoment) }}</span>
          </li>
        </ul>
      </div>
      <div class="upcoming">
        <span>{{ $resx("Publish.Upcoming") }}</span>
        <ul>
          <li class="placeholder" v-if="upcoming.length === 0">
            <span>{{ $resx("Publish.NoUpcoming") }}</span>
          </li>
          <li v-for="(publish, idx) in upcoming" :key="idx">
            <span>{{ formatDate(publish.PublishMoment) }}</span>
            <font-awesome-icon
              :icon="icons.trash"
              @click="removePublish(publish.ID)"
            />
          </li>
        </ul>
      </div>
    </div>
    <div class="column is-8">
      <span>{{ $resx("Publish.Publish") }}</span>
      <div class="columns is-variable is-3">
        <div class="column is-6">
          <switch-button
            :onText="$resx('Publish.AsSoonAsPossible')"
            v-model="soonAsPossible"
          ></switch-button>
          <date-time-picker
            v-model="value"
            :pickTime="true"
            :format="'DD-MM-YYYY HH:mm'"
            :inputAttributes="{ readonly: true }"
            :isDateDisabled="isDisabledDate"
            :hasInputElement="false"
            :setTimeCaption="$resx('Publish.Time') + ':'"
            :selectableYearRange="[currentYear, currentYear + 40]"
            :disabled="soonAsPossible"
            :weekdays="[
              $resx('Publish.Weekdays.Mon'),
              $resx('Publish.Weekdays.Tue'),
              $resx('Publish.Weekdays.Wed'),
              $resx('Publish.Weekdays.Thu'),
              $resx('Publish.Weekdays.Fri'),
              $resx('Publish.Weekdays.Sat'),
              $resx('Publish.Weekdays.Sun'),
            ]"
            :months="[
              $resx('Publish.Months.January'),
              $resx('Publish.Months.February'),
              $resx('Publish.Months.March'),
              $resx('Publish.Months.April'),
              $resx('Publish.Months.May'),
              $resx('Publish.Months.June'),
              $resx('Publish.Months.July'),
              $resx('Publish.Months.August'),
              $resx('Publish.Months.September'),
              $resx('Publish.Months.October'),
              $resx('Publish.Months.November'),
              $resx('Publish.Months.December'),
            ]"
          ></date-time-picker>
        </div>
        <div class="column is-6">
          <div class="columns is-multiline">
            <div class="column is-12">
              <h4 class="title is-6">{{ $resx("Publish.PublishAt") }}:</h4>
              {{ soonAsPossible ? $resx("Publish.AsSoonAsPossible") : value }}
            </div>
            <div class="column is-12" v-if="Object.keys(profile).length > 0">
              <h4 class="title is-6">{{ $resx("Publish.PublishBy") }}:</h4>
              {{ profile.Fullname }}
            </div>
            <div class="themes column is-12" v-if="length > 0">
              <h4 class="title is-6">{{ $resx("Publish.PublishThemes") }}:</h4>
              <div class="columns is-multiline">
                <div
                  class="column is-12"
                  v-for="(culture, idx) in unpublishedThemes"
                  :key="idx"
                >
                  <div class="field">
                    <div class="control has-icons-left">
                      <div class="select">
                        <select
                          @change="setPublishData($event.target.value, idx)"
                        >
                          <option :value="false" selected>
                            {{ $resx("Publish.NoTheme") }}
                          </option>
                          <option
                            v-for="(theme, idx_t) in culture"
                            :value="theme.ID"
                            :key="idx_t"
                          >
                            {{ theme.Title }}
                          </option>
                        </select>
                      </div>
                      <div class="icon is-small is-left">
                        <span
                          :class="[
                            'flag flag-size-xs flag-' +
                              idx.split('-').reverse()[0].toLowerCase(),
                          ]"
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dateTimePicker from '@/components/admin/DateTimePicker.vue'
import { faTrashAlt } from '@fortawesome/pro-regular-svg-icons'
import loader from '@/components/Loader.vue'
import switchButton from '@/components/admin/Switch.vue'
import { confirm } from '@/mixins/confirm.js'

export default {
  name: 'modalPublish',
  data () {
    return {
      loading: false,
      currentYear: new Date().getFullYear(),
      value: this.formatDate('now'), // '01-04-2020 12:30'
      publishes: [],
      lastPublishDate: new Date(),
      soonAsPossible: false,
      icons: {
        trash: faTrashAlt
      }
    }
  },
  components: {
    dateTimePicker,
    loader,
    switchButton
  },
  mixins: [confirm],
  computed: {
    length () {
      return Object.keys(this.unpublishedThemes).length
    },
    profile () {
      return this.$auth.via_me().get() || {}
    },
    upcoming () {
      var self = this
      var tmp = []
      var now = new Date()
      for (var i = 0; i < self.publishes.length; i++) {
        if (now < new Date(self.publishes[i].PublishMoment)) {
          tmp.push(self.publishes[i])
        }
        var publishmoment = new Date(self.publishes[i].PublishMoment)
        if (publishmoment > self.lastPublishDate) {
          self.lastPublishDate = publishmoment
        }
      }
      self.setDateValue()
      return tmp.reverse()
    },
    lastTwo () {
      var self = this
      var tmp = [
        {
          PublishMoment: new Date('01-01-1900')
        },
        {
          PublishMoment: new Date('01-01-1900')
        }
      ]
      var now = new Date()
      for (var i = 0; i < self.publishes.length; i++) {
        var moment = new Date(self.publishes[i].PublishMoment)
        if (moment < now) {
          if (new Date(tmp[0].PublishMoment) < moment) {
            tmp[0] = self.publishes[i]
          } else if (new Date(tmp[1].PublishMoment) < moment) {
            tmp[1] = self.publishes[i]
          }
        }
      }
      return tmp
    },
    unpublishedThemes () {
      var self = this
      var tmp = {}
      self.$store.state.unpublishedThemes.forEach((theme) => {
        // unpublishedThemes
        if (theme.Culture !== '') {
          if (!tmp.hasOwnProperty(theme.Culture)) {
            tmp[theme.Culture] = []
          }

          tmp[theme.Culture].push(theme)
        }
      })
      return tmp
    }
  },
  methods: {
    setDateValue: function () {
      var self = this
      self.value = this.formatDate(self.lastPublishDate)
    },
    setPublishData: function (value, key) {
      this.$emit('setPublishData', { Key: key, Value: value })
    },
    formatDate: function (string) {
      var tmp = ''
      if (string !== '') {
        var d = string === 'now' ? new Date() : new Date(string)
        if (d instanceof Date && !isNaN(d.valueOf())) {
          tmp =
            ('0' + d.getDate()).slice(-2) +
            '-' +
            ('0' + (d.getMonth() + 1)).slice(-2) +
            '-' +
            d.getFullYear() +
            ' ' +
            ('0' + d.getHours()).slice(-2) +
            ':' +
            ('0' + d.getMinutes()).slice(-2)
        }
      }
      return tmp
    },
    isDisabledDate (date) {
      var self = this
      var comparer = new Date(self.lastPublishDate.getTime())
      comparer.setDate(comparer.getDate() - 1)
      return date < comparer
    },
    removePublish (id) {
      var self = this

      self.confirm({
        message: self.$resx('Global.AreYouSure'),
        buttons: [
          {
            name: self.$resx('Buttons.Cancel'),
            class: 'is-pulled-left'
          },
          {
            name: self.$resx('Buttons.Yes'),
            class: 'is-pulled-right is-danger',
            action: function () {
              self.loading = true
              self
                .$http({
                  method: 'DELETE',
                  url: '/publish/' + id,
                  api: 'website',
                  name:
                    process.env.VUE_APP_NAME + '_' + self.$store.state.language
                })
                .then((response) => {
                  self.$store.dispatch('setSnack', {
                    message: self.$resx('Publish.Removed')
                  })
                  self.getPublishes()
                })
                .catch(function (err) {
                  self.$store.dispatch('setSnack', {
                    message: err.message
                  })
                  self.loading = false
                })
            }
          }
        ]
      })
    },
    getPublishes () {
      var self = this
      self.loading = true
      self
        .$http({
          method: 'GET',
          url: '/publish',
          api: 'website',
          name: process.env.VUE_APP_NAME + '_' + self.$store.state.language
        })
        .then((response) => {
          self.lastPublishDate = new Date()
          self.publishes = response.data
          self.loading = false
        })
        .catch(function (err) {
          self.$store.dispatch('setSnack', {
            message: err.message
          })
          self.loading = false
        })
    }
  },
  mounted () {
    var self = this
    self.getPublishes()
  },
  watch: {
    value: {
      handler: function (val) {
        if (new Date() >= new Date(val)) {
          this.setPublishData(-1, 'PublishMoment')
        } else {
          var pattern = /(\d{2})-(\d{2})-(\d{4})\s(\d{2}):(\d{2})/
          var dt = new Date(
            val.replace(pattern, '$3/$2/$1 $4:$5:00')
          ).toISOString()
          this.setPublishData(dt, 'PublishMoment')
        }
      },
      immediate: true
    },
    soonAsPossible: {
      handler: function (val) {
        if (val) {
          this.setPublishData(-1, 'PublishMoment')
        }
      },
      immediate: true
    },
    lastPublishDate: {
      handler: function (val) {
        this.$emit('lastMoment', val)
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
#publish {
  > .column {
    // .themes{
    &.is-8 {
      border-left: 1px solid $grey-lighter;
      .themes h4 {
        margin-bottom: 0.6rem;
      }
    }
    > span {
      display: inline-block;
      vertical-align: top;
      padding: 0px 10px;
      text-align: left;
      font-size: 75%;
      opacity: 0.8;
      height: 26px;
    }
    .upcoming,
    .lasttwo {
      > span {
        display: block;
        // margin: 10px 0px 5px 0px;
        opacity: 0.4;
      }

      ul {
        overflow-y: auto;
        box-sizing: border-box;
        padding: 0;
        border-radius: 4px;
        list-style: none;

        li {
          position: relative;
          height: auto;
          display: block;
          width: 100%;
          border-radius: 4px;
          padding: 10px 20px;

          &:last-of-type {
            margin-bottom: 20px;
          }

          &:not(.placeholder) {
            border: 1px solid $grey-lighter;
            background-color: $grey-bg;
          }

          + li {
            margin-top: 10px;
          }
          &:hover {
            svg {
              opacity: 0.4;
            }
          }
          svg {
            position: absolute;
            right: 10px;
            top: 14px;
            opacity: 0;
            transition: opacity 150ms ease-in-out;
            &:hover {
              opacity: 1;
              cursor: pointer;
            }
          }
        }
      }
    }
    .lasttwo {
      ul {
        li {
          padding-left: 40px;
          > img {
            height: 22px;
            position: absolute;
            left: 8px;
          }
        }
      }
    }
  }
}
</style>
